/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Button, Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IContentBlockWithSelectorViewProps } from './content-block-with-selector';

const ContentBlockWithSelectorView: React.FC<IContentBlockWithSelectorViewProps> = props => {
    const items = props.slots && props.slots.content && props.slots.content.length > 0 ? props.slots.content : [];
    const [currentContent, setCurrentContent] = React.useState<React.ReactNode>(items[0]);
    const buttons: JSX.Element[] = [];

    items.forEach(item => {
        const itemElement = item as React.ReactElement;
        const isActive = itemElement.props.friendlyName === (currentContent as React.ReactElement).props.friendlyName;

        if (itemElement) {
            buttons.push(
                <Button
                    className={isActive ? 'active' : ''}
                    onClick={() => {
                        setCurrentContent(itemElement);
                    }}
                >
                    {itemElement.props.friendlyName}
                </Button>
            );
        }
    });

    return (
        <Module {...props.container} {...props.renderModuleAttributes(props)}>
            <div className='buttons'>{buttons}</div>
            {currentContent}
        </Module>
    );
};

export default ContentBlockWithSelectorView;
